import { render } from "./GAPAnalysis.vue?vue&type=template&id=83ebc36c&scoped=true"
import script from "./GAPAnalysis.vue?vue&type=script&lang=js"
export * from "./GAPAnalysis.vue?vue&type=script&lang=js"

import "./GAPAnalysis.vue?vue&type=style&index=0&id=83ebc36c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-83ebc36c"

export default script